import { Link } from 'react-router-dom';
import ScrollReveal from '../../../components/ui/ScrollReveal';

export default function CTASection() {
  return (
    <section className="relative min-h-[540px] flex items-center overflow-hidden py-16 lg:py-24">
      <div className="absolute inset-0">
        <img
          src="/images/FR035635.jpg"
          alt="Start your transformation with Laura Martin personal trainer London"
          loading="lazy"
          className="w-full h-full object-cover object-[50%_30%]"
        />
        <div className="absolute inset-0 bg-[#1c1917]/82" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1c1917]/95 via-[#1c1917]/65 to-[#1c1917]/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-xl">
          <ScrollReveal>
            <div className="flex items-center gap-4 mb-6">
              <span className="w-8 h-px bg-[#c9a96e]" />
              <span className="text-[#c9a96e] text-[10px] font-sans font-semibold tracking-[0.32em] uppercase">Ready To Begin?</span>
            </div>
            <h2
              className="text-white mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2.6rem, 6vw, 5rem)', fontWeight: 600, lineHeight: 1.0 }}
            >
              Your Journey
              <br />
              <em className="text-[#c9a96e] not-italic">Starts Today.</em>
            </h2>
            <p className="text-white/65 font-sans text-base leading-relaxed mb-10 max-w-sm">
              Book a free consultation and take the first step towards the transformation you deserve.
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <Link to="/contact" className="px-9 py-4 bg-[#c9a96e] text-white text-[10px] font-sans font-bold tracking-[0.28em] uppercase rounded-full hover:bg-[#a8863f] hover:shadow-2xl hover:shadow-[#c9a96e]/30 hover:-translate-y-0.5 transition-all duration-300">
                Book Free Consultation
              </Link>
              <Link to="/services" className="px-9 py-4 border border-white/40 text-white text-[10px] font-sans font-bold tracking-[0.28em] uppercase rounded-full hover:border-white/70 hover:bg-white/10 transition-all duration-300">
                View Services
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
